import React, { useState } from "react";
import PartnerHeader from "./PartnerHeader";
import { Col, Container, Form, Row } from "react-bootstrap";
import SettingsTitle from "../dashboard/SettingsTitle";
import FormLabel from "../../common/FormLabel";
import RoundButton from "../../common/RoundButton";
import DeleteAccount from "../dashboard/DeleteAccount";
import ChangePasswordModal from "../dashboard/ChangePasswordModal";
import { useAuth } from "../../auth/Auth";

const CampAccountSettings = () => {
    const { school } = useAuth();
    const [showPasswordModal, setShowPassWordModal] = useState(false);

    const handleCloseShowPasswordModal = () => {
        setShowPassWordModal(false);
    };

    return (
        <div className="guardian-setting-wrapper partner-setting-wrapper partner-wrapper-main">
            <PartnerHeader />
            <Container fluid="md">
                <Row className="mt-3">
                    <Col className="col-md-8 col-lg-6">
                        <SettingsTitle title="Account details" />
                        <Form>
                            <div className="align-self-center guardian-account-property">
                                <FormLabel>Account email: {school?.email}</FormLabel>
                            </div>
                            <div className="mb-3">
                                <RoundButton
                                    type="button"
                                    label="Change password"
                                    onClick={() => setShowPassWordModal(true)}
                                    className="mt-3 change-password-button gred-btn"
                                />
                            </div>
                            <div className="guardian-account-sublabel">
                                Sign in again after changing your password
                            </div>
                        </Form>
                    </Col>
                </Row>
                {/* <Row className="mt-3">
                    <Col className="col-md-8 col-lg-6">
                        <SettingsTitle title="Resources" />
                        <div className="mb-3">
                            <a href={guidePdf} without="true" rel="noopener noreferrer" target="_blank">
                                <RoundButton
                                    type="button"
                                    label="TaleTree Creative Camp Guide"
                                    // onClick={() => setShowPassWordModal(true)}
                                    className="mt-3 change-password-button gred-btn"
                                />
                            </a>
                        </div>
                    </Col>
                </Row> */}
                <DeleteAccount
                    text={"If you still want to delete your account, please send your request to"}
                />
            </Container>
            <ChangePasswordModal
                showPasswordModal={showPasswordModal}
                handleClose={handleCloseShowPasswordModal}
            />
        </div>
    )
}

export default CampAccountSettings;